import { WidgetConfig } from "@/types";
import {
  useFetchTestimonials,
  useGetSocialProofAssetById,
} from "../testimonial-gallery/api/queries";
import { AnimatedTestimonials } from "./components/animated-testimonials";

interface Props {
  projectId: string;
}

export const AnimatedShowCaseCarousel = ({ projectId }: Props) => {
  const { data, isPending } = useFetchTestimonials({
    projectId,
    published: true,
    type: "text",
  });

  const testimonials = data?.map(({ content, customer }) => ({
    quote: content,
    name: customer.name,
    designation: customer.title || customer.username || "",
    src: customer.avatar || "",
  }));

  return (
    <div>
      {isPending ? (
        <div></div>
      ) : (
        <AnimatedTestimonials testimonials={testimonials!} />
      )}
    </div>
  );
};

export const AnimatedCarouselComponentWidget: React.FC<WidgetConfig> = ({
  widgetId,
}) => {
  const { data: widget, isPending } = useGetSocialProofAssetById({
    id: widgetId,
  });

  if (!widget || isPending) return null;

  return <AnimatedShowCaseCarousel projectId={widget.projectId!} />;
};
